/**
 *
 *  ? url pada submenu menggunakana naming routes,
 *  ? jadi tidak perlu dibuat format url lengkap
 */
export default [
  {
    icon: "UsersIcon",
    menu: "Dosen Wali",
    url: "dekan-dosen-wali",
  },
  {
    icon: "UsersIcon",
    menu: "Kelas",
    url: "dekan-kelas",
  },
  {
    icon: "ListIcon",
    menu: "Kurikulum",
    url: "dekan-kurikulum",
  },

  {
    icon: "UsersIcon",
    menu: "Mahasiswa",
    url: "dekan-mahasiswa",
  },
  {
    icon: "PieChartIcon",
    menu: "Rekap Perkuliahan",
    url: "dekan-rekap-perkuliahan",
  },
];
